export const initialState = {
  isGrantingPremium: false,
  isRevokingPremium: false,
  grantPremiumSuccess: null,
  revokePremiumSuccess: null,
  error: null,
};
